export const Field = ({ id, label, optional, error, children }) => (
  <div>
    <label htmlFor={id} className="mb-1.5 block font-semibold">
      {label} {optional && <span className="font-normal text-[var(--ink-soft)]">(valfritt)</span>}
    </label>
    {children}
    {error && (
      <p id={`${id}-error`} className="mt-1.5 text-sm font-medium text-[var(--red)]" role="alert" data-testid={`error-${id}`}>
        {error}
      </p>
    )}
  </div>
);
